import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const logout = () => api.post("/auth/logout");
export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchGigs = (params) => api.get("/gigs", { params }).then((r) => r.data);
export const fetchGig = (id) => api.get(`/gigs/${id}`).then((r) => r.data);
export const createGig = (data) => api.post("/gigs", data).then((r) => r.data);
export const updateGig = (id, data) => api.patch(`/gigs/${id}`, data).then((r) => r.data);
export const deleteGig = (id) => api.delete(`/gigs/${id}`);
export const fetchMyGigs = () => api.get("/my/gigs").then((r) => r.data);
export const pauseGig = (id, paused) => api.post(`/gigs/${id}/pause`, { paused }).then((r) => r.data);
export const fetchUser = (id) => api.get(`/users/${id}`).then((r) => r.data);
export const updateMe = (data) => api.patch("/auth/me", data).then((r) => r.data);
export const createOrder = (data) => api.post("/orders", data).then((r) => r.data);
export const fetchOrders = (role) => api.get("/orders", { params: { role } }).then((r) => r.data);
export const fetchOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data);
export const updateOrderStatus = (id, status) => api.patch(`/orders/${id}/status`, { status }).then((r) => r.data);
export const fetchReviews = (params) => api.get("/reviews", { params }).then((r) => r.data);
export const createReview = (data) => api.post("/reviews", data).then((r) => r.data);
export const sendMessage = (data) => api.post("/messages", data).then((r) => r.data);
export const fetchConversations = () => api.get("/messages/conversations").then((r) => r.data);
export const fetchThread = (otherId) => api.get(`/messages/${otherId}`).then((r) => r.data);
export const uploadFile = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const seedData = () => api.post("/seed").then((r) => r.data);

// Favorites
export const toggleFavorite = (gig_id) => api.post(`/favorites/${gig_id}`).then((r) => r.data);
export const fetchFavorites = () => api.get("/favorites").then((r) => r.data);
export const fetchFavoriteIds = () => api.get("/favorites/ids").then((r) => r.data);

// Related
export const fetchRelated = (gig_id) => api.get(`/gigs/${gig_id}/related`).then((r) => r.data);

// Revisions
export const requestRevision = (order_id, reason) => api.post(`/orders/${order_id}/revisions`, { reason }).then((r) => r.data);

// Earnings & withdrawal
export const previewFee = (amount) => api.get("/earnings/fee-preview", { params: { amount } }).then((r) => r.data);

// Review reply / summary
export const fetchReviewSummary = (params) => api.get("/reviews/summary", { params }).then((r) => r.data);
export const replyToReview = (review_id, reply) => api.post(`/reviews/${review_id}/reply`, { reply }).then((r) => r.data);

// Messages – read receipts + presence
export const markThreadRead = (other_id) => api.post(`/messages/${other_id}/read`).then((r) => r.data);
export const fetchPresence = (ids) => api.get("/presence", { params: { ids: ids.join(",") } }).then((r) => r.data);

// Admin
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminUsers = (q) => api.get("/admin/users", { params: q ? { q } : {} }).then((r) => r.data);
export const adminUpdateUser = (id, data) => api.patch(`/admin/users/${id}`, data).then((r) => r.data);
export const adminGigs = (params) => api.get("/admin/gigs", { params }).then((r) => r.data);
export const adminUpdateGig = (id, data) => api.patch(`/admin/gigs/${id}`, data).then((r) => r.data);
export const adminOrders = (params) => api.get("/admin/orders", { params }).then((r) => r.data);
export const adminRefundOrder = (id) => api.post(`/admin/orders/${id}/refund`).then((r) => r.data);
export const adminWithdrawals = (params) => api.get("/admin/withdrawals", { params }).then((r) => r.data);
export const adminUpdateWithdrawal = (id, payload) => api.patch(`/admin/withdrawals/${id}`, payload).then((r) => r.data);

// Buyer Request Board
export const fetchRequests = (params) => api.get("/requests", { params }).then((r) => r.data);
export const fetchRequest = (id) => api.get(`/requests/${id}`).then((r) => r.data);
export const createRequest = (data) => api.post("/requests", data).then((r) => r.data);
export const closeRequest = (id) => api.delete(`/requests/${id}`).then((r) => r.data);
export const fetchRequestOffers = (id) => api.get(`/requests/${id}/offers`).then((r) => r.data);
export const createOffer = (id, data) => api.post(`/requests/${id}/offers`, data).then((r) => r.data);
export const acceptOffer = (id) => api.post(`/offers/${id}/accept`).then((r) => r.data);
export const withdrawOffer = (id) => api.post(`/offers/${id}/withdraw`).then((r) => r.data);
export const fetchMyOffers = () => api.get("/offers/mine").then((r) => r.data);
export const adminReviews = () => api.get("/admin/reviews").then((r) => r.data);
export const adminDeleteReview = (id) => api.delete(`/admin/reviews/${id}`).then((r) => r.data);

// Buyer home
export const fetchBuyerHome = () => api.get("/buyer/home").then((r) => r.data);

// Analytics
export const fetchAnalytics = (days) => api.get("/admin/analytics", { params: { days } }).then((r) => r.data);

// Verification
export const applyVerification = (data) => api.post("/verification/apply", data).then((r) => r.data);
export const fetchMyVerification = () => api.get("/verification/me").then((r) => r.data);
export const adminListVerifications = (status) => api.get("/admin/verifications", { params: status ? { status } : {} }).then((r) => r.data);
export const adminDecideVerification = (id, decision, reason) => api.patch(`/admin/verifications/${id}`, { decision, reason }).then((r) => r.data);

// Announcements
export const fetchActiveAnnouncement = () => api.get("/announcements/active").then((r) => r.data);
export const adminListAnnouncements = () => api.get("/admin/announcements").then((r) => r.data);
export const adminCreateAnnouncement = (text, active = true) => api.post("/admin/announcements", { text, active }).then((r) => r.data);
export const adminDeleteAnnouncement = (id) => api.delete(`/admin/announcements/${id}`).then((r) => r.data);

// Disputes
export const raiseDispute = (order_id, reason) => api.post(`/orders/${order_id}/disputes`, { reason }).then((r) => r.data);
export const fetchOrderDisputes = (order_id) => api.get(`/orders/${order_id}/disputes`).then((r) => r.data);
export const adminListDisputes = (status) => api.get("/admin/disputes", { params: status ? { status } : {} }).then((r) => r.data);
export const adminResolveDispute = (id, resolution, admin_note = "") =>
  api.patch(`/admin/disputes/${id}`, { resolution, admin_note }).then((r) => r.data);
export const fetchDisputeMessages = (dispute_id) => api.get(`/disputes/${dispute_id}/messages`).then((r) => r.data);
export const postDisputeMessage = (dispute_id, text) => api.post(`/disputes/${dispute_id}/messages`, { text }).then((r) => r.data);

// Payments
export const createCheckout = (order_id) =>
  api.post("/payments/checkout", { order_id, origin_url: window.location.origin }).then((r) => r.data);
export const getPaymentStatus = (session_id) => api.get(`/payments/status/${session_id}`).then((r) => r.data);
export const razorpayConfig = () => api.get("/payments/razorpay/config").then((r) => r.data);
export const razorpayCheckout = (order_id) => api.post("/payments/razorpay/checkout", { order_id }).then((r) => r.data);
export const razorpayVerify = (data) => api.post("/payments/razorpay/verify", data).then((r) => r.data);

// Deliverables
export const addDeliverable = (order_id, data) =>
  api.post(`/orders/${order_id}/deliverables`, { order_id, ...data }).then((r) => r.data);

// Earnings
export const fetchEarnings = () => api.get("/earnings").then((r) => r.data);
export const requestWithdrawal = (data) => api.post("/earnings/withdraw", data).then((r) => r.data);

// Notifications
export const fetchNotifications = () => api.get("/notifications").then((r) => r.data);
export const markNotificationsRead = () => api.post("/notifications/read").then((r) => r.data);

// WebSocket token
export const fetchWsToken = () => api.get("/auth/ws-token").then((r) => r.data);

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
};

export const wsUrl = (token) => {
  const wsProto = BACKEND_URL.startsWith("https") ? "wss" : "ws";
  const host = BACKEND_URL.replace(/^https?:\/\//, "");
  return `${wsProto}://${host}/api/ws?token=${encodeURIComponent(token)}`;
};
